import * as React from "react";
import { Modal, Button, Tooltip } from "antd";
import ManageDriverForm from "../Form/ManageDriverForm";
import {
  EditOutlined,

  // CloseOutlined,
  // CheckOutlined,
} from "@ant-design/icons";

export const ManageDriverModalContext = React.createContext<{
  setIsModalVisible: (active: boolean) => void;
}>({
  setIsModalVisible: () => true,
});

const DriverManageModal: React.FC<{ id: number }> = ({ id }) => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const showModal = () => setIsModalVisible(true);

  const handleOk = () => setIsModalVisible(false);

  const handleCancel = () => setIsModalVisible(false);

  return (
    <ManageDriverModalContext.Provider value={{ setIsModalVisible }}>
      <Tooltip title="Edit/Update">
        <Button
          onClick={showModal}
          type="primary"
          shape="circle"
          icon={<EditOutlined />}
        />
      </Tooltip>
      <Modal
        title="Manage Assigned Person"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <ManageDriverForm id={id} />
      </Modal>
    </ManageDriverModalContext.Provider>
  );
};

export default DriverManageModal;
